import config from '../config';

const {
	HOST: { HCM_BASE_DOMAIN_URL }
} = config;

const PaycorApp = window.PaycorApp;
export const initCompanySwitcher = () => {
	if (typeof PaycorApp !== 'undefined') {
		if (process.env.NODE_ENV !== 'production') {
			PaycorApp.CompanyClient.setIsLocalDevelopment(true);
		}

		PaycorApp.CompanyClient.setup({
			shouldShowSwitcher: true,
			pageType: PaycorApp.CompanyClient.pageTypeEnum.CLIENT,
			changeListener: (selection) => {
				if (selection && selection.clientId && selection.companyId) {
					const clientURl = HCM_BASE_DOMAIN_URL + `/employeesettings/#/Company/${selection.companyId}/Client/${selection.clientId}`;
					window.history.pushState('', '', clientURl);
					window.location.reload(true);
				}
			}
		});
		console.debug('paycor-app-utility - initCompanySwitcher - complete');
	}
};

export const getSelectedCompanyClient = async () => {
	let clientId = null;
	let clientName = '';
	let companyId = null;
	const selectedFromSessionStorage = await PaycorApp.CompanyClient.getSelectedCompanyClient();
	if (Boolean(selectedFromSessionStorage)) {
		const { companyId: storedCompanyId, clientId: storedClientId, clientName: storedClientName } = selectedFromSessionStorage;
		if (storedCompanyId && storedCompanyId >= 0) {
			companyId = storedCompanyId;
		}
		if (storedClientId && storedClientId >= 0) {
			clientId = storedClientId;
		}
		if (storedClientName && storedClientName.length > 0) {
			clientName = storedClientName;
		}
	}
	return { clientId, companyId, clientName };
};

export const getSelectedClientId = async () => {
	let clientId = null;
	const selectedClientFromStorage = await PaycorApp.CompanyClient.getSelectedClient();
	if (Boolean(selectedClientFromStorage)) {
		const storedClientId = selectedClientFromStorage.clientId;
		if (storedClientId && storedClientId >= 0) {
			clientId = storedClientId;
		}
	}
	return clientId;
};
export const setSelectedClient = async (clientId) => {
	let selectedClientData = {};
	await PaycorApp.CompanyClient.setSelectedClient(`${clientId}`)
		.catch((reason) => console.debug('setSelectedClient failed', reason))
		.then((response) => {
			if (response) {
				console.debug(`setSelectedClient response: ${JSON.stringify(response)}`);
				Object.assign(selectedClientData, response);
			}
		});
	return selectedClientData;
};
